import { DataViewProps } from '../../view/common/DataView';
import { AgentDef } from '../mgmt/api';
import { useStatefulWebSocketListener, useWebSocketListener } from '../WebSocketListener';

export const useAgentDefListener = function (
    props: DataViewProps<AgentDef>
) {
    const agentDef = props.data;
    const id = agentDef?.id;

    return useStatefulWebSocketListener({
        ...props,
        endPoint: '/agent/websocket',
        topic: id && `/topic/agentDef/${id}` || undefined,
    });
};

